"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const videobrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-videobrand04` : '') + (description ? ` desc-videobrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-videobrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-videobrand04"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M70 65.73c0 2.358-1.91 4.27-4.267 4.27H10.267A4.268 4.268 0 0 1 6 65.73V10.286C6 7.919 7.91 6 10.267 6h55.466C68.09 6 70 7.919 70 10.286V65.73Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 24a1 1 0 0 1 1 1v36.684C2 63.526 3.473 65 5.267 65h55.466C62.527 65 64 63.526 64 61.684V25a1 1 0 1 1 2 0v36.684C66 64.61 63.653 67 60.733 67H5.267C2.347 67 0 64.61 0 61.684V25a1 1 0 0 1 1-1ZM5.267 2A3.276 3.276 0 0 0 2 5.286V15h62V5.286A3.276 3.276 0 0 0 60.733 2H5.267ZM0 5.286C0 2.37 2.354 0 5.267 0h55.466C63.646 0 66 2.37 66 5.286V16a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5.286Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.258.034a1 1 0 0 1 .708 1.224l-4 15a1 1 0 1 1-1.932-.516l4-15a1 1 0 0 1 1.224-.708ZM46.258.034a1 1 0 0 1 .708 1.224l-4 15a1 1 0 1 1-1.932-.516l4-15a1 1 0 0 1 1.224-.708ZM26.02 32.147a1.397 1.397 0 0 0-2.02 1.25v16.206a1.397 1.397 0 0 0 2.02 1.25l16.208-8.105a1.395 1.395 0 0 0 0-2.495L26.02 32.147Zm-2.41-1.639c1-.619 2.25-.676 3.303-.151l16.209 8.106a3.394 3.394 0 0 1 0 6.074l-16.21 8.106A3.397 3.397 0 0 1 22 49.603V33.397c0-1.177.609-2.27 1.61-2.889Z"
  }))));
};
var _default = exports.default = videobrand04;